module.exports = "/images/about_logo_aws.png?116b0d268d8b875c6fa55c98cad07302";